import type { Drone } from '../../types';
import { getWarrantyDaysRemaining } from '../getWarrantyDaysRemaining';

import { formatToUSDate } from '@@utils/dateTimeUtils/dateFormatUtil';

type AircraftInfoLabels = {
    droneSerial: string;
    emDash: string;
    faaRegistration: string;
    firmwareVersion: string;
    unitDays: string;
    warrantyEnd: string;
    warrantyExpired: string;
    warrantyRemaining: string;
    warrantyStart: string;
};

export type AircraftInfoRow = { label: string; value: string };

export const getAircraftInfo = ({
    drone,
    labels,
    now
}: {
    drone: Drone;
    labels: AircraftInfoLabels;
    now: Date;
}): AircraftInfoRow[] => {
    const { emDash } = labels;
    const warrantyStart = drone.warranty ? formatToUSDate(new Date(drone.warranty.start)) : emDash;
    const warrantyEnd = drone.warranty ? formatToUSDate(new Date(drone.warranty.end)) : emDash;
    const daysRemaining = drone.warranty
        ? getWarrantyDaysRemaining({ end: drone.warranty.end, now })
        : null;

    const getWarrantyRemaining = (): string => {
        if (daysRemaining === null) {
            return emDash;
        }

        if (daysRemaining <= 0) {
            return labels.warrantyExpired;
        }

        return `${daysRemaining} ${labels.unitDays}`;
    };

    return [
        { label: labels.faaRegistration, value: drone.faaRegistrationNumber ?? emDash },
        { label: labels.droneSerial, value: drone.serial },
        { label: labels.firmwareVersion, value: drone.firmwareVersion },
        { label: labels.warrantyStart, value: warrantyStart },
        { label: labels.warrantyEnd, value: warrantyEnd },
        { label: labels.warrantyRemaining, value: getWarrantyRemaining() }
    ];
};
